module.exports = ".dropzone {\n  text-align: center;\n  border: 1px dashed white;\n  background-color: transparent !important; }\n\n.obra-selected-fotografia {\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/catalogo-obras/catalogo-obras-fotografia/catalogo-obras-fotografia.component.scss
// module id = ./src/app/components/catalogo-obras/catalogo-obras-fotografia/catalogo-obras-fotografia.component.scss
// module chunks = main